import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import LogoUTI from '../Login/LogoUTI.png';
import injupemp from '../Login/injupemp.png';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from 'react-router-dom';
import { post } from '../../services/http';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import WarningIcon from '@mui/icons-material/Warning';
import { useContext } from "react";
import { ContextSession } from '../../services/ContextSession';
function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://www.injupemp.gob.hn/">
        INJUPEMP
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const defaultTheme = createTheme();

async function doLogin(event, flag) {
  event.preventDefault();
  let fla = flag ? 1 : 0;
  const data = new FormData(event.currentTarget);
  let email = data.get('email'),
    password = data.get('password');
  let json = { username: email, password: password, ldap: fla };
  let url = "";

  //url = "http://172.20.7.21:8080/api/auth/ldap";
  url = "http://172.20.7.10:8082/api/auth/ldap"; //pruebas
  //url="https://institutoalfonsohernandezcordova.com/Secretaria/Angular2/session.php";
  let datas = await post(url, json);



  return datas;
};

export default function SignInSide() {
  let sessi = useContext(ContextSession);
  const navigate = useNavigate();
  const [imageLoaded, setImageLoaded] = useState(false);
  const [emailValue, setEmailValue] = useState('');
  const [passwordValue, setPasswordValue] = useState('');
  const [isDominioActive, setIsDominioActive] = useState(true);
  const [intentos, setIntentos] = useState(0);
  const [openDialog, setOpenDialog] = useState(false); // Estado del diálogo
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false); // Estado del botón de envío
  const [emailValid, setEmailValid] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);

  const handleEmailChange = (event) => {
    setEmailValue(event.target.value);
    const email = event.target.value;
    setEmailValue(email);
    setEmailValid(email.length >= 3);
  };

  const handlePasswordChange = (event) => {
    setPasswordValue(event.target.value);
    const password = event.target.value;
    setPasswordValue(password);
    setPasswordValid(password.length >= 3);
  };

  function handleSetDominio() {
    setIsDominioActive((isDominioActive) => !isDominioActive);
  }
  useEffect(() => {
    const img = new Image();
    img.src = 'http://academia.injupemp.gob.hn/wp-content/uploads/2023/07/logo-injupemp.png';
    img.onload = () => {
      setImageLoaded(true);
    };
    img.onerror = (error) => {
      console.error('Error loading image:', error);
    };
  }, []);

  const handleSubmit = async (event) => {
    let datas;


    datas = await doLogin(event, isDominioActive);

    //console.log(datas);
    if (!datas.error) {
      sessi.setUsername(emailValue);
      sessi.sessionStart(datas);

      navigate('/Inicio');
    } else {
      setIntentos((intentos) => intentos + 1);
      if (intentos === 2) {
        setOpenDialog(true); // Mostrar diálogo cuando se alcance el límite de intentos
        setSubmitButtonDisabled(true); // Deshabilitar el botón de inicio de sesión
      }
      //console.log("CANTIDAD DE INTENTOS",intentos);
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${injupemp})`,
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 3,
              mx: 7, //5 para que ambos checkbox estén en la misma linea
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >

            {imageLoaded ? (
              <img
                src="http://academia.injupemp.gob.hn/wp-content/uploads/2023/07/logo-injupemp.png"
                alt="INJUPEMP Logo"
                style={{ width: '30%', height: '30%', objectFit: 'cover' }}
              />
            ) : null}

            <Typography component="h1" variant="h5">
              Inicio De Sesión
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>

              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Usuario"
                name="email"
                autoComplete="email"
                autoFocus
                value={emailValue}
                onChange={handleEmailChange}
                InputProps={{
                  startAdornment: (
                    <AccountCircleIcon sx={{ marginRight: '8px' }} color={emailValue ? "disabled" : "action"} />
                  ),
                }}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="current-password"
                value={passwordValue}
                onChange={handlePasswordChange}
                InputProps={{
                  startAdornment: (
                    <LockIcon sx={{ marginRight: '8px' }} color={passwordValue ? "disabled" : "action"} />
                  ),
                }}
              />
              <Box>
                <FormControlLabel
                  control={<Checkbox value="remember" color="primary" />}
                  label="Recuérdame"
                />
                <FormControlLabel
                  control={<Checkbox value="dominio" checked={isDominioActive} onChange={handleSetDominio} color="primary" />}
                  label="Ingresar con usuario de dominio"
                />
              </Box>
              {intentos > 0 && (
                <Alert severity="error">Credenciales Invalidas, Intento {intentos}/3</Alert>)}


              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={!emailValid || !passwordValid || submitButtonDisabled} // Estado de deshabilitación del botón
              >
                Iniciar Sesión
              </Button>

              <Grid item xs style={{ textAlign: 'center' }}>
                <img src={LogoUTI} alt="Logo UTI" style={{ width: '30%', height: '30%', objectFit: 'contain' }} />
              </Grid>

              <Copyright sx={{ mt: 0 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Box display="flex" alignItems="center">
            <WarningIcon sx={{ mr: 1 }} style={{ color: "red" }} />
            {"Límite de intentos alcanzado, contacte al administrador"}
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" align='justify'>
            Recuerde que su usuario de dominio es el mismo con el que inicia sesión en windows, y si excede su número de intentos permitidos, este se bloqueará.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Entendido
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
